import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { NgOtpInputComponent } from 'ng-otp-input';
import { Membro } from 'src/app/modules/_models/membro';
import { statusAtivo } from 'src/app/modules/_models/statusMembroLogin.model';
import { AuthService } from 'src/app/modules/_services/auth.service';
import * as alerts from '../../../_functions/alerts';
import { FidelidadeService } from '../../../_services/fidelidade.service';

@Component({
  selector: 'app-esqueci-minha-senha',
  templateUrl: './esqueci-minha-senha.component.html',
  styleUrls: ['./esqueci-minha-senha.component.scss'],
})
export class EsqueciMinhaSenhaComponent implements OnInit {
  @Output() public abrirAcesso: EventEmitter<null> = new EventEmitter();
  @Output() public enviado: EventEmitter<boolean> = new EventEmitter();

  @ViewChild(NgOtpInputComponent, { static: false })
  ngOtpInput: NgOtpInputComponent;

  // Form
  public cpf: string = '';
  public senha: string = '';
  public senhaConfirma: string = '';
  public exibeErro: boolean = false;
  public senhaValida: boolean = false;
  public mostrarSenha: boolean = false;
  public mostrarConfirmaSenha: boolean = false;

  // Membro
  membro: Membro = new Membro();

  otpInputConfig = {
    allowNumbersOnly: true,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: '',
    inputStyles: {
      width: '2.5rem',
      height: '3rem',
      'border-radius': '1.5rem',
      'font-family': 'Sagona',
      'font-size': '24px',
    },
  };

  // Loadings
  public enviando: boolean = false;
  public realizandoEnvioEmail: boolean = false;
  public realizandoEnvioCelular: boolean = false;
  public salvandoSenha: boolean = false;
  public realizandoLoginMembro: boolean = false;

  // etapas
  public paraEnviarCodigo: string = '';
  public etapaAtual: number = 1;
  private sessaoAtual: statusAtivo;
  private metodoDeReset: string = '';
  private readonly METODO__EMAIL: string = 'email';
  private readonly METODO__CELULAR: string = 'celular';
  public readonly ETAPA__ENVIO: number = 1;
  public readonly ETAPA__PINCODE: number = 2;
  public readonly ETAPA__CONFIRMACAO: number = 3;
  public habilitaReenvio: boolean = false;
  public counter: number = 5;
  public realizandoLogin: boolean = false;
  public codigoInvalido: string = 'Código inválido';
  public habilitaCodigoInvalido: boolean = false;
  public habilitarSenha: boolean = false;
  public habilitaMsgNaoEnvio: boolean = false;
  public passwordValidate: boolean = false;
  public interval;

  constructor(
    private fidelidadeService: FidelidadeService,
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      if (params.popupEsqueciSenha) {
        let popupEsqueciSenha = atob(params.popupEsqueciSenha);
        if (!popupEsqueciSenha.includes('@')) {
          this.cpf = popupEsqueciSenha;
        }
      } else {
        this.cpf = '';
      }
    });

    this.verificaCPF();
  }

  irParaAcesso() {
    clearInterval(this.interval);
    if (this.etapaAtual < this.ETAPA__ENVIO)
      this.etapaAtual = this.ETAPA__ENVIO;

    if (this.etapaAtual === this.ETAPA__PINCODE) {
      this.counter = 30;
      this.habilitarSenha = false;
      this.etapaAtual--;
      this.habilitaCodigoInvalido = false;
      return;
    }
    this.abrirAcesso.emit();
    this.router.navigate(['/home']);
  }

  enviarEmail() {
    this.enviando = true;
    this.exibeErro = false;

    if (!this.cpf) {
      this.exibeErro = true;
      return;
    }

    this.fidelidadeService.enviarEmailEsqueciSenhaMembro(this.cpf).subscribe(
      (sucesso) => {
        this.processarSucesso(sucesso);
      },
      (falha) => {
        this.processarFalha(falha);
      }
    );
  }

  processarSucesso(response: any) {
    let emailTruncate = '';

    var email = response.email.split('@');

    if (response.email)
      emailTruncate =
        email[0].substring(0, 4) + '...@' + email[1].substring(0, 5);

    this.router.navigate(['/']);

    alerts.exibirSwal(
      'success',
      'Obaaa 😍',
      `<div class="text-left">
                Foi enviado o e-mail para <strong>${emailTruncate}...</strong>

                contendo as informações.
                <br>
                Cheque sua caixa de entrada para redefinir.
             </div>`,
      'center',
      6000
    );
    this.enviando = false;
    this.enviado.emit(false);
  }

  processarFalha(fail: any) {
    if (fail == 'Cpf não cadastrado em nossa base de dados!') {
      alerts.exibirSwal(
        'info',
        'Poxaaa 😥',
        `<div class="text-left"> Seu CPF não foi encontrado em nossa base. </div>`
      );
      this.enviando = false;
      return;
    }

    alerts.exibirSwal(
      'error',
      'Atenção',
      `<div class="text-left"> ${fail} </div>`
    );
    this.enviando = false;
  }

  public verificaCPF(): void {
    let verificaStatus = true;
    let senha = '';
    if (this.cpf.length >= 11) {
      this.authService
        .retornaStatusMembro(this.cpf, senha, verificaStatus)
        .subscribe({
          next: (res: statusAtivo) => {
            this.sessaoAtual = res;
          },
          error: (err: any) => {
            console.log(err);
          },
        });
    }
  }

  public enviarCodigo(metodo: string) {
    if (this.cpf == '') {
      return alerts.exibirSwal(
        'warning',
        'Atenção',
        'Informe o cpf.',
        'center',
        8000
      );
    }

    this.habilitaReenvio = false;

    this.counter = 30;
    this.interval = setInterval(() => {
      if (this.counter > 0) {
        this.counter--;
        this.habilitaReenvio = false;
        this.habilitaMsgNaoEnvio = false;
      } else {
        this.habilitaMsgNaoEnvio = true;
        this.habilitaReenvio = true;
      }
    }, 1000);

    if (metodo === this.METODO__CELULAR) {
      this.metodoDeReset = metodo;
      this.realizandoEnvioCelular = true;

      this.authService.retornaStatusMembro(this.cpf, '', true).subscribe({
        next: (res: statusAtivo) => {
          this.sessaoAtual = res;
          this.enviarTokenParaCelular(this.sessaoAtual.token);
        },
        error: (err: any) => {
          console.error(err);
        },
      });


    } else {
      this.metodoDeReset = metodo;
      this.realizandoEnvioEmail = true;

      this.authService.retornaStatusMembro(this.cpf, '', true).subscribe({
        next: (res: statusAtivo) => {
          this.sessaoAtual = res;
          this.enviarTokenParaEmail(this.sessaoAtual.token);
        },
        error: (err: any) => {
          console.error(err);
        },
      });

    }
  }

  private enviarTokenParaEmail(token: string) {
    this.fidelidadeService
      .enviarEmailValidarEmailComToken(token)
      .subscribe({
        next: (sucesso: any) => {
          this.etapaAtual = this.ETAPA__PINCODE;
          this.paraEnviarCodigo = `${sucesso.resultado}`;
          this.realizandoEnvioEmail = false;
        },
        error: (err: any) => {
          this.realizandoEnvioEmail = false;

          return alerts.exibirSwal(
            'warning',
            'Atenção',
            'Houve um problema para enviar o código.',
            'center',
            8000
          );
        },
      });
  }

  public validarCodigo(otp: string) {
    let pinCode: string = otp;

    if (pinCode?.length < 6) return;

    if (this.metodoDeReset == this.METODO__CELULAR) this.validarSms(pinCode);
    if (this.metodoDeReset == this.METODO__EMAIL) this.validarEmail(pinCode);
  }

  private validarSms(pinCode: string) {
    this.realizandoLogin = true;
    this.fidelidadeService
      .validarPinCodeSmsValidarCampoComToken(pinCode)
      .subscribe(
        (sucesso) => {
          this.sessaoAtual.token = sucesso.resultado;
          if (!sucesso.erro) {
            this.habilitarSenha = true;
            this.ngOtpInput.otpForm.disable();
            clearInterval(this.interval);
            this.habilitaMsgNaoEnvio = false;
            this.habilitaCodigoInvalido = false;
            this.counter = 30;
          } else {
            this.realizandoLogin = false;
            this.habilitaCodigoInvalido = true;
            return;
          }
        },
        (falha) => {
          console.log(falha);
          return alerts.exibirSwal(
            'warning',
            'Atenção',
            'Houve um problema para validar o código, é preciso reenviar o código.',
            'center',
            8000
          );
        }
      );
  }

  private validarEmail(pinCode: string) {
    this.realizandoLogin = true;
    this.fidelidadeService
      .validarPinCodeEmailValidarCampoComToken(pinCode)
      .subscribe(
        (sucesso) => {
          this.sessaoAtual.token = sucesso.resultado;
          if (!sucesso.erro) {
            this.habilitarSenha = true;
            this.ngOtpInput.otpForm.disable();
            clearInterval(this.interval);
            this.habilitaMsgNaoEnvio = false;
            this.habilitaCodigoInvalido = false;
            this.counter = 30;
          } else {
            this.realizandoLogin = false;
            this.habilitaCodigoInvalido = true;
            return;
          }
        },
        (falha) => {
          console.log(falha);
          return alerts.exibirSwal(
            'warning',
            'Atenção',
            'Houve um problema para validar o código, é preciso reenviar o código.',
            'center',
            8000
          );
        }
      );
  }

  public passwordValidateFunc(event: boolean): void {
    this.passwordValidate = event
  }

  public confirmarResetSenha() {
    if (!this.passwordValidate) return
    this.membro.cpf = this.cpf.replace(/\./g, '').replace(/-/g, '');
    this.membro.senha = this.senha;
    this.membro.senhaConfirmacao = this.senhaConfirma;

    if (this.membro.senha !== this.membro.senhaConfirmacao) {
      return alerts.exibirSwal(
        'warning',
        'Atenção',
        'Os campos de senha e confirmação de senha estão divergentes!',
        'center',
        8000
      );
    }

    this.salvandoSenha = true;

    this.fidelidadeService
      .atualizarMembroSenha(this.sessaoAtual.token, this.membro)
      .subscribe({
        next: (res: any) => {
          this.etapaAtual = this.ETAPA__CONFIRMACAO;
          this.salvandoSenha = false;
        },
        error: (err: any) => {
          console.log(err);
          this.salvandoSenha = false;
          return alerts.exibirSwal(
            'warning',
            'Atenção',
            'Houve um problema para alterar sua senha.',
            'center',
            8000
          );
        },
      });
  }

  public reenviarCodigo() {
    this.counter = 30;

    if (this.metodoDeReset === this.METODO__EMAIL) {
      this.fidelidadeService
        .enviarEmailValidarEmailComToken(this.sessaoAtual.token)
        .subscribe(
          (sucesso: any) => { },
          (falha: any) => {
            console.log(falha);
            return alerts.exibirSwal(
              'warning',
              'Atenção',
              'Houve um problema ao reenviar o código sms.',
              'center',
              8000
            );
          }
        );
    }
    if (this.metodoDeReset === this.METODO__CELULAR) {
      this.fidelidadeService
        .enviarSmsValidarCampoComToken(this.sessaoAtual.token)
        .subscribe(
          (sucesso: any) => { },
          (falha: any) => {
            console.log(falha);
            return alerts.exibirSwal(
              'warning',
              'Atenção',
              'Houve um problema ao reenviar o código sms.',
              'center',
              8000
            );
          }
        );
    }
  }

  public realizarLogin() {
    this.realizandoLoginMembro = true;
    this.authService
      .loginComSenha(this.membro.cpf, this.membro.senha)
      .subscribe(
        (res) => {
          this.processarSucessoLogin(res);
        },
        (falha) => {
          this.realizandoLoginMembro = true;
          console.log(falha);
          return alerts.exibirSwal(
            'warning',
            'Atenção',
            'Houve um problema ao realizar login.',
            'center',
            8000
          );
        }
      );
  }

  private processarSucessoLogin(res: statusAtivo) {
    this.authService.LocalStorage.salvarDadosLocaisUsuario(res);

    this.fidelidadeService.obterMembro().subscribe({
      next: (sucesso: any) => {
        this.authService.LocalStorage.salvarMembro(sucesso);
        this.router.navigate(['/index']);
        this.realizandoLoginMembro = false;
      },
      error: (err: any) => {
        console.log(err);
        this.realizandoLoginMembro = false;
        return alerts.exibirSwal(
          'warning',
          'Atenção',
          'Houve um problema ao encontrar o membro.',
          'center',
          8000
        );
      },
    });
  }

  public visualizarSenha() {
    this.mostrarSenha = !this.mostrarSenha;
  }
  public visualizarConfirmaSenha() {
    this.mostrarConfirmaSenha = !this.mostrarConfirmaSenha;
  }

  private enviarTokenParaCelular(token: string): void {
    this.fidelidadeService.enviarSmsValidarCampoComToken(token).subscribe({
      next: (sucesso: any) => {
        this.etapaAtual = this.ETAPA__PINCODE;
        this.paraEnviarCodigo = `${sucesso.resultado}`;
        this.realizandoEnvioCelular = false;
      },
      error: (err: any) => {
        this.realizandoEnvioCelular = false;
        this.exibirAlerta('warning', 'Atenção', 'Houve um problema para enviar o código.');
      },
    });
  }

  private exibirAlerta(type: string, title: string, message: string): void {
    alerts.exibirSwal(type, title, message, 'center', 8000);
  }
}
